export class DriverListAssignmentFilterEntity {
  searchWord?: string
  from?: string
  to?: string
  driverId?: number
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
